import request from '@/util/request';

// 分页列表
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/audio/page', Object.assign({}, options, { params }));

// 收藏的分页列表
export const getCollectionPageListApi = (params, options) =>
  request.get('/api/v4ward/callcenter/audio/favorite/page', Object.assign({}, options, { params }));

// 收藏|取消收藏
export const collectionApi = (params, options) =>
  request.post('/api/v4ward/callcenter/audio/favorite', params, options, {
    'Content-Type': 'application/json',
  });

// 评分
export const scoreApi = (params, options) =>
  request.post('/api/v4ward/callcenter/audio/score', params, options, {
    'Content-Type': 'application/json',
  });
